module.exports = __webpack_public_path__ + "static/media/prise-pres-lit.b911d8ec.svg";